import * as dayjs from 'dayjs'
import solana from './solana'
import {
    useWallet
} from 'solana-wallets-vue'

export default {
    mixins: [solana],
    methods: {
        async listeners() {
            window.LaravelEcho.connector.pusher.connection.bind('state_change', (states) => {
                this.pusherState = states.current
                this.debug.messages.push('State Prev: ' + states.previous + ' State Current: ' + states.current)
                if (states.current === 'connected') {
                    this.debug.messages.push('Pusher Connected: updating queue')
                    this.fetchLatestMessages()
                    this.updateQueue()
                }
            })
            window.LaravelEcho.channel('global-chat').listen('MessageEvent', (e) => {
                this.globalChat.messages.push(e.data)
                this.globalChat.lastUpdate = dayjs()
                if (this.activePane === 'global-chat') {
                    this.globalChat.lastSeen = dayjs()
                }
                if (this.globalChat.lastUpdate.isAfter(this.globalChat.lastSeen)) {
                    this.globalChat.new++
                }
            })
            window.LaravelEcho.channel('jackpot').listen('JackpotUpdated', (e) => {
                this.jackpot.current = e.data.current
                this.jackpot.next = e.data.next
                this.jackpot.turns = e.data.turns
            })
            window.LaravelEcho.channel('queue').listen('QueueUpdated', (e) => {
                this.gamesList.queue = e.data.queue
                this.gamesList.private_queue = e.data.private_queue
                this.gamesList.spectate_queue = e.data.spectate_queue
                this.gamesList.online = e.data.online
                if (this.gameLobby.show && !this.gamesList.online) {
                    this.activePane = 'games-list'
                    this.gameLobby.item = null
                    this.gameLobby.show = false
                    this.gamesList.show = true
                }
            })
            window.LaravelEcho.channel('queue').listen('SpecialRefreshed', () => {
                this.fetchPrivateGamesAvailable()
                this.updateQueue()
            })
            window.LaravelEcho.channel('queue').listen('SpecialGameStarted', (e) => {
                const wallets = e.data.wallets
                const walletFound = wallets.includes(useWallet().publicKey.value.toString())
                if (e.data.game_id == this.gameLobby.game.id && this.gameLobby.show && !walletFound) {
                    this.activePane = 'games-list'
                    this.gameLobby.item = null
                    this.gameLobby.show = false
                    if (this.gamesList.tab === 'specials' && this.gamesList.private_queue.length === 0 && !this.isTeamWallet) {
                        this.gamesList.tab = 'sitAndGo'
                    }
                    this.gamesList.show = true
                }
            })
            this.updateQueue()
            this.emitter.on('account-menu-toggle', () => {
                this.emitter.emit('play-click')
                this.accountMenuShow = !this.accountMenuShow
            })
            this.emitter.on('toggle-dark-mode', () => {
                // this.isDark = !this.isDark
                this.isDark = true
                localStorage.setItem('darkMode', this.isDark)
            })
            this.emitter.on('toggle-sound', () => {
                this.sound = !this.sound
                localStorage.setItem('sound', this.sound)
                this.toggleSound()
            })
            this.emitter.on('login', () => {
                this.signIn()
            })
            this.emitter.on('close-modal', (value) => {
                this.modals[value] = false
            })
            this.emitter.on('open-modal', (value) => {
                this.modals[value] = true
            })
            this.emitter.on('change-pfp', (value) => {
                this.account.pfp = value
            })
            this.emitter.on('play-new-race', () => {
                    this.sounds.newRace.seek(0)
                    this.sounds.newRace.play()
                }),
                this.emitter.on('play-click', () => {
                    this.sounds.click.seek(0)
                    this.sounds.click.play()
                }),
                // Game Lobby
                this.emitter.on('go-to-game-lobby', (item) => {
                    this.emitter.emit('play-click')
                    this.activePane = 'games-list'
                    this.gameLobby.game = item
                    this.gamesList.show = false
                    this.gameLobby.show = true
                })
            // Buttons
            this.emitter.on('notifications-toggle', () => {
                this.emitter.emit('play-click')
                this.notifications.show = !this.notifications.show
                if (this.notifications.show) {
                    this.notifications.lastSeen = dayjs()
                    this.notifications.new = 0
                    this.transactions.show = false
                    this.admin.show = false
                    this.revenue.show = false
                    this.gamesList.show = false
                    this.gameLobby.show = false
                    this.globalChat.show = false
                    this.yourGamesList.show = false
                    this.appInfo.show = false
                    this.gameConfig.show = false
                    this.game.show = false
                } else {
                    this.gamesList.show = this.activePane == 'games-list' ? true : false
                    this.globalChat.show = this.activePane == 'global-chat' ? true : false
                    this.gameConfig.show = this.activePane == 'game-config' ? true : false
                    this.yourGamesList.show = this.activePane == 'your-games-list' ? true : false
                    this.appInfo.show = this.activePane == 'app-info' ? true : false
                    this.transactions.show = this.activePane == 'transactions' ? true : false
                    this.revenue.show = this.activePane == 'revenue' ? true : false
                }
            })
            this.emitter.on('transactions-show', () => {
                this.activePane = 'transactions'
                this.transactions.show = true
                this.admin.show = false
                this.revenue.show = false
                this.notifications.show = false
                this.gamesList.show = false
                this.gameLobby.show = false
                this.globalChat.show = false
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = false
                this.game.show = false
            })
            this.emitter.on('revenue-show', () => {
                this.activePane = 'revenue'
                this.transactions.show = false
                this.admin.show = false
                this.revenue.show = true
                this.notifications.show = false
                this.gamesList.show = false
                this.gameLobby.show = false
                this.globalChat.show = false
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = false
                this.game.show = false
            })
            this.emitter.on('games-list-clicked', () => {
                this.emitter.emit('play-click')
                this.activePane = 'games-list'
                this.transactions.show = false
                this.admin.show = false
                this.revenue.show = false
                this.notifications.show = false
                this.gamesList.show = true
                this.gameLobby.show = false
                this.globalChat.show = false
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = false
                this.game.show = false
                if (this.activePane !== 'games-list') {
                    this.updateQueue()
                }
            })
            this.emitter.on('global-chat-clicked', () => {
                this.emitter.emit('play-click')
                this.activePane = 'global-chat'
                this.globalChat.lastSeen = dayjs()
                this.globalChat.new = 0
                this.transactions.show = false
                this.admin.show = false
                this.revenue.show = false
                this.notifications.show = false
                this.gamesList.show = false
                this.gameLobby.show = false
                this.globalChat.show = true
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = false
                this.game.show = false
            })
            this.emitter.on('game-config-clicked', () => {
                this.emitter.emit('play-click')
                this.activePane = 'game-config'
                this.transactions.show = false
                this.admin.show = false
                this.revenue.show = false
                this.notifications.show = false
                this.gamesList.show = false
                this.gameLobby.show = false
                this.globalChat.show = false
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = true
                this.game.show = false
            })
            this.emitter.on('app-info-clicked', () => {
                    this.emitter.emit('play-click')
                    this.activePane = 'app-info'
                    this.transactions.show = false
                    this.admin.show = false
                    this.revenue.show = false
                    this.notifications.show = false
                    this.gamesList.show = false
                    this.gameLobby.show = false
                    this.globalChat.show = false
                    this.yourGamesList.show = false
                    this.appInfo.show = true
                    this.gameConfig.show = false
                    this.game.show = false
                }),
                this.emitter.on('your-games-list-clicked', () => {
                    this.emitter.emit('play-click')
                    this.activePane = 'your-games-list'
                    this.yourGamesList.lastSeen = dayjs()
                    this.yourGamesList.new = 0
                    this.transactions.show = false
                    this.admin.show = false
                    this.revenue.show = false
                    this.notifications.show = false
                    this.gamesList.show = false
                    this.gameLobby.show = false
                    this.globalChat.show = false
                    this.yourGamesList.show = true
                    this.appInfo.show = false
                    this.gameConfig.show = false
                    this.game.show = false
                }),
                this.emitter.on('select-game', (data) => {
                    this.emitter.emit('play-click')
                    this.emitter.emit('close-modal', 'start_game_modal')
                    this.activePane = 'your-games-list'
                    if (data) {
                        this.game.id = data.game_id
                        this.game.template_id = data.game_template_id
                        this.game.status = data.status
                        const winnerIndex = data.players.indexOf(data.players.find(player => player.place === 1))
                        if (winnerIndex !== -1) {
                            this.game.winner = data.players[winnerIndex].id
                        }
                    }
                    this.transactions.show = false
                    this.admin.show = false
                    this.revenue.show = false
                    this.notifications.show = false
                    this.gamesList.show = false
                    this.gameLobby.show = false
                    this.globalChat.show = false
                    this.yourGamesList.show = false
                    this.appInfo.show = false
                    this.gameConfig.show = false
                    this.game.show = true
                })
            this.emitter.on('admin-show-clicked', () => {
                this.emitter.emit('play-click')
                this.activePane = 'admin-show'
                this.transactions.show = false
                this.admin.show = true
                this.revenue.show = false
                this.notifications.show = false
                this.gamesList.show = false
                this.gameLobby.show = false
                this.globalChat.show = false
                this.yourGamesList.show = false
                this.appInfo.show = false
                this.gameConfig.show = false
                this.game.show = false
            })
            this.emitter.on('show-all-games-list-toggle', () => {
                this.yourGamesList.showAll = !this.yourGamesList.showAll
                this.getGamesList(1)
            })
            this.emitter.on('load-more-games-list', () => {
                this.emitter.emit('play-click')
                this.getGamesList(this.yourGamesList.next_page)
            })
            this.emitter.on('reset-game', () => {
                this.game.show = false
                this.game.id = null
                this.game.template_id = null
                this.game.status = null
                this.game.players = [],
                    this.game.messages = []
                this.game.countdown = -1
                this.game.log = false
                this.game.turns = 0
                this.game.winner = null
                this.game.token_awarded = false
            })
            this.emitter.on('show-log', () => {
                this.emitter.emit('play-click')
                this.game.log = !this.game.log
            })
            this.emitter.on('toggle-auto-start', () => {
                this.account.start_game = !this.account.start_game
                axios.post('/api/account/toggleautostart', {
                    start_game: this.account.start_game
                }, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                })

            })
        },
        privateListeners() {
            window.LaravelEcho.private(`tokens.${useWallet().publicKey.value.toString()}`).listen('TokensUpdated', (e) => {
                this.tokensBalance.topaz = e.data.topaz
                this.tokensBalance.sapphire = e.data.sapphire
                this.tokensBalance.emerald = e.data.emerald
                this.tokensBalance.ruby = e.data.ruby
            })
            window.LaravelEcho.private(`tickets.${useWallet().publicKey.value.toString()}`).listen('TicketsUpdated', (e) => {
                this.ticketsBalance.apex = e.data.apex
                this.ticketsBalance.burnout = e.data.burnout
                this.ticketsBalance.torque = e.data.torque
                this.ticketsBalance.shakedown = e.data.shakedown
                this.ticketsBalance.brass = e.data.brass
            })
            window.LaravelEcho.private(`account.${useWallet().publicKey.value.toString()}`).listen('AccountInfoUpdated', (e) => {
                this.account = e.account
            })
            window.LaravelEcho.private(`games.${useWallet().publicKey.value.toString()}`).listenToAll((e, data) => {
                this.handlePrivateGamesChannel(e, data)
            })
            window.LaravelEcho.private(`spins.${useWallet().publicKey.value.toString()}`).listenToAll((e, data) => {
                switch (e) {
                    case 'SpinReady':
                        this.spin.ready = true
                        break;
                    case 'SpinResult':
                        this.spin.prize = data.data.prize
                        break;
                }
            })
            window.LaravelEcho.private(`notifications.${useWallet().publicKey.value.toString()}`).listenToAll((e, data) => {
                this.notifications.lastUpdate = dayjs()
                if (this.notifications.lastUpdate.isAfter(this.notifications.lastSeen)) {
                    this.notifications.new++
                }
                let amount, message, retries, contactTeam, ticket_type
                switch (e) {
                    case 'JoinedGame':
                        this.emitter.emit('play-new-race')
                        if (this.account.start_game || data.data.spectator) {
                            this.modals.name_modal = false
                            this.modals.pfp_modal = false
                            this.modals.deposit_modal = false
                            this.modals.withdraw_modal = false
                            this.modals.start_game_modal = false
                            this.modals.swap_tokens_modal = false
                            this.modals.spin_modal = false
                            this.game.id = data.data.game_id
                            this.game.template_id = data.data.game_template_id
                            this.emitter.emit('select-game', null)
                        } else if (this.gameLobby.show && !this.account.start_game) {
                            this.gameLobby.show = false
                            this.gamesList.show = true
                            this.gamesList.tab = 'sitAndGo'
                            this.game.id = data.data.game_id
                            this.game.template_id = data.data.game_template_id
                            this.emitter.emit('open-modal', 'start_game_modal')
                        }
                        let spectatorStr = ''
                        const spectator = data.data.spectator === true
                        if (spectator) {
                            spectatorStr = ' as spectator'
                        }
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You joined a ' + data.data.room + ' race' + spectatorStr,
                            new: true
                        })
                        this.updateQueue()
                        break
                    case 'WonGame':
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You won a ' + data.data.room + ' race',
                            new: true
                        })
                        break
                    case 'WithdrawSuccessful':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You withdrew ' + amount + ' SOL',
                            new: true
                        })
                        break
                    case 'DepositSuccessful':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You deposited ' + amount + ' SOL',
                            new: true
                        })
                        break
                    case 'DepositFailed':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        retries = data.data.retries
                        contactTeam = retries == 5 ? ' Contact team in Discord!' : ''
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'Failed deposit of ' + amount + ' SOL (Retries: ' + retries + '/5)' + contactTeam,
                            new: true
                        })
                        break
                    case 'WithdrawFailed':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        retries = data.data.retries
                        contactTeam = retries == 5 ? ' Contact team in Discord!' : ''
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'Failed withdraw of ' + amount + ' SOL (Retries: ' + retries + '/5)' + contactTeam,
                            new: true
                        })
                        break
                    case 'JackpotWon':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You won the Jackpot: ' + amount + ' SOL 🎉',
                            new: true
                        })
                        break
                    case 'TokenAwarded':
                        if (data.data.token_type === 'manual') {
                            message = 'You received a token: ' + data.data.token_name;
                        } else if (data.data.token_type === 'race') {
                            message = 'You won a token: ' + data.data.token_name;
                        } else if (data.data.token_type === 'swap') {
                            message = 'You received a token from a swap: ' + data.data.token_name;
                        } else if (data.data.token_type === 'spin') {
                            message = 'You won a token in a spin: ' + data.data.token_name;
                        }
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: message,
                            new: true
                        })
                        break
                    case 'SolAwarded':
                        amount = this.lamportsToSol(Math.abs(data.data.amount))
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You won ' + amount + ' SOL in the Spinner',
                            new: true
                        })
                        break;
                    case 'TicketAwarded':
                        ticket_type = data.data.type.charAt(0).toUpperCase() + data.data.type.slice(1)
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You won a free ticket: ' + ticket_type,
                            new: true
                        })
                        break;
                    case 'TicketUsed':
                        ticket_type = data.data.type.charAt(0).toUpperCase() + data.data.type.slice(1)
                        this.notifications.messages.unshift({
                            created_at: dayjs().toISOString(),
                            message: 'You used a free ticket (' + ticket_type + ')',
                            new: true
                        })
                        break;
                    default:
                        // console.log(e, data)
                        break
                }
            })
            window.LaravelEcho.join('users')
                .joining((user) => {
                    this.users.push(user)
                })
                .leaving((user) => {
                    this.users.splice(this.users.indexOf(user), 1)
                })
                .here((users) => {
                    this.users = users
                })
        },
        handlePrivateGamesChannel(e, data) {
            let gameIndex
            switch (e) {
                case 'GameCreatedNotify':
                    this.getGamesList()
                    this.yourGamesList.lastUpdate = dayjs()
                    if (this.yourGamesList.lastUpdate.isAfter(this.yourGamesList.lastSeen)) {
                        this.yourGamesList.new++
                    }
                    break;
                case 'GameCreated':
                    if (data.data.wallet !== null) {
                        this.game.id = data.data.game_id
                        this.game.template_id = data.data.game_template_id
                    }
                    break;
                case 'PlayersUpdated':
                    if (this.game.id == data.data.game_id) {
                        this.game.players = data.data.players
                        this.game.turns = data.data.turns
                    }
                    break;
                case 'GameMessage':
                    if (this.game.id == data.data.game_id) {
                        this.game.messages.push(data.data.message)
                    }
                    break;
                case 'GameGrid':
                    if (this.game.id == data.data.game_id) {
                        this.game.grid = data.data.grid
                    }
                    break;
                case 'GameCountdown':
                    if (this.game.id == data.data.game_id) {
                        this.game.countdown = data.data.countdown
                    }
                    break;
                case 'GameStarted':
                    gameIndex = this.yourGamesList.games.indexOf(this.yourGamesList.games.find(game => game.id == data.data.game_id))
                    if (gameIndex !== -1) {
                        const startedGame = this.yourGamesList.games[gameIndex]
                        startedGame.status = 'running'
                    }
                    break;
                case 'GameEnded':
                    if (this.game.id == data.data.game_id) {
                        this.game.winner = data.data.winner_id
                    }
                    gameIndex = this.yourGamesList.games.indexOf(this.yourGamesList.games.find(game => game.id == data.data.game_id))
                    if (gameIndex !== -1) {
                        const endedGame = this.yourGamesList.games[gameIndex]
                        endedGame.status = 'ended'
                        endedGame.turns = data.data.turns
                        endedGame.token_awarded = data.data.token_awarded
                        endedGame.ended_at = dayjs()
                        data.data.players.forEach(player => {
                            const matchingPlayerIndex = endedGame.players.findIndex(p => p.id === player.id)
                            if (matchingPlayerIndex !== -1) {
                                endedGame.players[matchingPlayerIndex].place = player.place;
                            }
                        })
                        endedGame.players.sort((a, b) => {
                            if (a.place === 1) return -1
                            if (b.place === 1) return 1
                            return a.place - b.place
                        })
                    }
                    break;
                default:
                    // console.log('Games Events', e, data)
                    break;
            }
        }
    },
}
